import { z } from "zod";
export const DecimalStringSchema = z.string().regex(/^(?:0|[1-9]\d*)$/, "Expected a canonical non-negative decimal string");
export const SignedDecimalStringSchema = z.string().regex(/^(?:0|-?[1-9]\d*)$/, "Expected a canonical decimal string");
export const UuidSchema = z.string().uuid();
export const UuidV7Schema = UuidSchema.refine((value) => value[14] === "7" && /^[89ab]$/i.test(value[19] ?? ""), "Expected a UUIDv7");
export const Rfc3339MillisSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/, "Expected UTC RFC3339 with milliseconds");
export const Sha256HexSchema = z.string().regex(/^[a-f0-9]{64}$/, "Expected lowercase SHA-256 hex");
export const Sha256Base64UrlSchema = z.string().regex(/^[A-Za-z0-9_-]{43}$/, "Expected unpadded base64url SHA-256");
export const LocaleSchema = z.enum(["ru", "en"]);
export const AccountKindSchema = z.enum(["real", "mock"]);
export const WorkspaceKindSchema = z.enum(["personal", "shared"]);
export const WorkspaceRoleSchema = z.enum(["owner", "editor", "viewer"]);
export const IdentitySchema = z
    .object({
    authSessionId: UuidSchema,
    actorAccountId: UuidSchema,
    effectiveAccountId: UuidSchema,
    simulationSessionId: UuidSchema.nullable(),
})
    .strict();
export const ActionCapabilitiesSchema = z
    .object({
    canEdit: z.boolean(),
    canPrompt: z.boolean(),
    canMove: z.boolean(),
    canAcceptProposal: z.boolean(),
    canCreateProject: z.boolean(),
    canManageProject: z.boolean(),
})
    .strict();
export const ErrorCodeSchema = z.enum([
    "AUTH_REQUIRED",
    "RECENT_AUTH_REQUIRED",
    "FORBIDDEN",
    "IDENTITY_CONFLICT",
    "INVALID_REQUEST",
    "NOT_FOUND",
    "STALE_REVISION",
    "STALE_BOARD_REVISION",
    "DUPLICATE_COMMAND",
    "EDIT_SESSION_ACTIVE",
    "PROPOSAL_CONFLICT",
    "CONNECTOR_OFFLINE",
    "MODEL_UNAVAILABLE",
    "SEARCH_FAILED",
    "LEASE_FENCED",
    "GRANT_FENCED",
    "UPLOAD_UNSAFE",
    "SCANNER_UNAVAILABLE",
    "SAVE_CONFLICT",
    "RATE_LIMITED",
    "INTERNAL_ERROR",
]);
export const ErrorEnvelopeSchema = z
    .object({
    error: z
        .object({
        code: ErrorCodeSchema,
        messageKey: z.string().regex(/^errors\.[A-Za-z0-9.]+$/),
        params: z.record(z.string(), z.union([z.string(), z.boolean(), DecimalStringSchema])).default({}),
        requestId: UuidSchema,
    })
        .strict(),
})
    .strict();
export const DatabaseSequenceSchema = DecimalStringSchema.refine((value) => BigInt(value) <= 9223372036854775807n, "Expected a signed 64-bit database sequence");
export const RevisionedCommandSchema = z
    .object({
    commandId: UuidSchema,
    revision: DatabaseSequenceSchema,
})
    .strict();
export const OpaqueCursorSchema = z.string().min(1).max(512);
export const PageLimitSchema = z.number().int().min(1).max(250);
//# sourceMappingURL=primitives.js.map